import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment as env } from "@environments/environment";
import { FundingDetails, FundingTrade, MilestoneDownloadedOption } from "../model/funding-details.model";

@Injectable({
	providedIn: "root"
})
export class FundingService {
	private http = inject(HttpClient);

	getFundingPdf(payCycleId: string, milestoneGroups?: string[]): Observable<Blob> {
		const url = `${
			env.apiUri
		}/v1/report/pay-cycle/${payCycleId}/funding/pdf?milestoneGroups=${milestoneGroups?.join(",")}`;
		return this.http.get(url, { responseType: "blob" });
	}

	getNetsFundingDetails(payCycleId: string): Observable<FundingDetails> {
		const url = `${env.apiUri}/v1/report/pay-cycle/${payCycleId}/funding/nets`;
		return this.http.get<FundingDetails>(url);
	}

	getTppFundingDetails(payCycleId: string, milestoneGroup: string): Observable<FundingDetails> {
		const url = `${env.apiUri}/v1/report/pay-cycle/${payCycleId}/funding/tpp?milestoneGroup=${milestoneGroup}`;
		return this.http.get<FundingDetails>(url);
	}

	recalculateFxForNonApi(sellAmount: FundingTrade["sellAmount"], milestoneId: string): Observable<unknown> {
		return this.http.put(`${env.apiUri}/v1/calendars/milestones/${milestoneId}/trade`, { sellAmount });
	}

	getAlreadyDownloadedMilestoneOptions(payCycleId: string | undefined): Observable<MilestoneDownloadedOption> {
		const url = `${env.apiUri}/v1/report/pay-cycle/${payCycleId}/funding/download-options`;
		return this.http.get<MilestoneDownloadedOption>(url);
	}
}
